import React, { Fragment, useEffect, useState } from "react";
const CreditAccordion = ({ content, headers, itemId }: any) => {
    const [active, setActive] = useState<{ [key: number]: boolean }>({});
    const handleActive = (i: any) => {
        setActive({ ...active, [i]: !active[i] });
    };

    useEffect(() => {
        let activeList: any = {};
        headers.forEach((elem: any, index: number) => {
            activeList[index] = false;
        });
        setActive(activeList);
    }, [headers]);

    const handleKeyPress = (e: React.KeyboardEvent<HTMLDivElement>, i: any) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleActive(i)
        }
    }
    return Array.isArray(content)
        ? headers.map((v: any, i: any) => {
              return (
                  <Fragment key={i}>
                      <div
                          className={`data-grid ${i < headers.length - 1 ? "has-lines" : ""} pointer ${active[i] ? "expand-credit-lock" : "collapse-credit-lock"}`}
                          onClick={() => handleActive(i)}
                          role="button"
                          tabIndex={0}
                          onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) => handleKeyPress(e, i)}
                          aria-expanded={active[i] ? "true" : "false"}
                          aria-controls={`${itemId}-${i}`}
                      >
                          <div className="row box" style={{ padding: "0px" }}>
                              <div className="col-xs-10 col-sm-10" style={{ paddingTop: "15px" }}>
                                  <div
                                      className="box-header"
                                      style={{
                                          display: "flex",
                                          alignItems: "center",
                                      }}
                                  >
                                      <div className="box-title-container" style={{ marginBottom: 0 }}>
                                          <div className="box-title-text">
                                              <h4 className="box-title">{v}</h4>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <div className="col-xs-2 col-sm-2 flex-end" style={{ paddingTop: 15 }}>
                                  <span className="fs-1-5">
                                      <em
                                          className="las la-angle-down"
                                          style={{
                                              transform: active[i] ? "rotate(180deg)" : "",
                                          }}
                                      ></em>
                                  </span>
                              </div>
                              <p id={`${itemId}-${i}` } >{active[i] ? content[i] : null}</p>
                          </div>
                      </div>
                  </Fragment>
              );
          })
        : null;
};

export default CreditAccordion;
